module.exports = __webpack_public_path__ + "assets/icon-hired.568c97c2.svg";